import React from "react";
import { useDispatch, useSelector } from "react-redux";
import DonutList from "../../../../components/donutList/donutList";
import { actionCreators } from "../redux/totalRevenueSagas";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";

const RevenueByType = () => {
  const dispatch = useDispatch();
  const {
    revenuesByType,
    revenuesTypes,
    defaultCheckedItems,
    checkedRevenueTypeIds,
    isUpdating,
    allRevenues: { currencySymbol }
  } = useSelector((state) => state.totalRevenue);

  return isUpdating ? (
    <div className="revenue-types-loader-wrapper">
      <LoadingAnimation customStyle="revenue-types-loader" />
    </div>
  ) : (
    <DonutList
      donutValues={revenuesByType.map((rev) => {
        return {
          ...rev,
          value: rev.share * 100,
          type: rev.name,
          dollarValue: rev.revenue,
          url: rev.categoryTotalSalesRawDataLink,
          fontSize: 21,
          hasMinusButton: true,
          id: rev.id,
          customTitleStyle: "title-height-60",
          currencySymbol: currencySymbol,
          toolTip: "Percentage change from previous month",
          centerToolTip: "Percentage of Month to Date Revenue"
        };
      })}
      groupValues={revenuesTypes}
      defaultCheckedItems={defaultCheckedItems}
      selectedItems={checkedRevenueTypeIds}
      title="Select Categories"
      module=".react-section-wrapper.revenueWidget"
      selectHeight={350}
      treeView
      modalHeight={450}
      modalMaxWidth="600px"
      modalMinWidth="300px"
      modalTop={220}
      maxDonuts={6}
      onMinusButtonClick={(donutProps) =>
        dispatch(actionCreators.removeRevenueCategory(donutProps))
      }
      itemWasChecked={(items) => dispatch(actionCreators.setRevenueTypesChecked(items))}
      onSubmit={() => dispatch(actionCreators.addRevenueChart())}
    />
  );
};

export default RevenueByType;
